import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = { key: 3 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.tag), { class: "w-full h-full" }, {
    default: _withCtx(() => [
      (_ctx.variant === _ctx.SkeletonVariantsEnum.RECTANGULAR)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(_ctx.finalClasses)
          }, null, 2))
        : (_ctx.variant === _ctx.SkeletonVariantsEnum.CIRCULAR)
          ? (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: _normalizeClass(_ctx.finalClasses)
            }, null, 2))
          : (_ctx.variant === _ctx.SkeletonVariantsEnum.LINE)
            ? (_openBlock(), _createElementBlock("div", {
                key: 2,
                class: _normalizeClass(_ctx.finalClasses)
              }, null, 2))
            : (_ctx.variant === _ctx.SkeletonVariantsEnum.TEXT)
              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.finalClasses)
                  }, null, 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.finalClasses)
                  }, null, 2),
                  _createElementVNode("div", {
                    class: _normalizeClass(_ctx.finalClasses)
                  }, null, 2)
                ]))
              : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}